function Logo() {
  return (
    <img src="/logo.svg" alt="TaTa Super Logo" width="78.42px" height="30px" />
  )
}

export default Logo
